import type { CellEntry } from '@ooh/contracts';
import type { CellState } from './availability-types';

/**
 * Maps a canonical CellEntry (status + ownership overlay) to the local grid CellState.
 *
 * Local grid states use old lowercase-hyphenated values ('free', 'option-own', etc.)
 * which drive the AvailabilityGrid's visual rendering (colors, hatch patterns, cursor).
 * This mapping is the single adapter for the canonical taxonomy.
 *
 * The dominant entry (highest STATUS_PRECEDENCE) is passed here after sorting.
 */
// eslint-disable-next-line complexity -- exhaustive status switch; each case is a single-line canonical mapping.
export function cellEntryToCellState(entry: CellEntry): CellState {
  const { status, ownership } = entry;

  switch (status) {
    case 'FREE':
      return 'free';
    case 'ASK_AVAILABILITY':
    case 'POTENTIAL':
      return 'unknown';
    case 'OPTION':
      return ownership === 'mine' ? 'option-own' : 'option-other';
    case 'SOFT_RESERVATION':
      return ownership === 'mine' ? 'reserved-own-soft' : 'reserved-other-soft';
    case 'HARD_RESERVATION':
      return ownership === 'mine' ? 'reserved-own-hard' : 'reserved-other-hard';
    case 'SOLD':
      return 'sold';
    case 'UNAVAILABLE':
      return 'unavailable';
    default:
      return 'unknown';
  }
}
